import styled from '@emotion/styled'
import { calcRem } from '../../../../../../__styling/style-functions/calc-rem'
import { colors } from '../../../../../../__styling/settings/colors'
import { transition } from '../../../../../../__styling/style-mixins'

interface StyledEqualiserContainerProps {
    height: number
    skewed?: boolean
}

export const StyledEqualiserContainer = styled('div')<
    StyledEqualiserContainerProps
>(({ height, skewed }) => ({
    height,
    display: 'flex',
    alignItems: 'flex-end',
    transform: skewed ? 'skew(-10deg)' : 'none',
}))

interface StyledBarProps {
    backgroundColor?: string
    skewed?: boolean
}

export const StyledBar = styled('span')<StyledBarProps>(
    ({ backgroundColor = colors.white, skewed }) => ({
        display: 'inline-block',
        width: skewed ? calcRem(6) : calcRem(4),
        height: '100%',
        marginRight: skewed ? calcRem(1) : calcRem(4),
        marginTop: 'auto',
        backgroundColor,
        borderRadius: 1,
        transformOrigin: 'center bottom',
        ...transition({ properties: ['transform'], speed: 'slow' }),
    }),
)
